<template>
  <div :class="['section', $style.uploadProgressContainer]">
    <div class="content has-text-centered">
      <div :class="['has-text-weight-semibold', $style.uploadRadialProgress]">
        <RadialProgressBar />
      </div>

      <p :class="$style.uploadDetails">
        {{ uploadStatus }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import RadialProgressBar from '@/jbi-shared/vue-components/RadialProgressBar.vue';

@Component({
  components: { RadialProgressBar },
})
export default class UploadLoading extends Vue {
  @Prop(Boolean) private isLoading!: boolean;
  @Prop(Boolean) private isSuccess!: boolean;

  get uploadStatus(): string | null {
    if (this.isLoading) {
      return 'Uploading...';
    } else if (this.isSuccess) {
      return 'Processing...';
    }
    return null;
  }
}
</script>

<style lang="scss" module>
@import './style.scss';
</style>
